import Section from "../section";

class Service extends Section{


}

export default Service



// WEBPACK FOOTER //
// ./scripts/catcalc/sections/service.js